var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "115",
        height: "115",
        viewBox: "0 0 115 115",
        fill: "none",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "115",
          height: "115",
          rx: "57.5",
          fill: "url(#paint0_linear_7_68)",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M73.5813 73.141C73.2933 75.027 73.0203 76.863 72.6813 79.114C71.4163 77.048 70.3063 75.341 69.3143 73.573C69.0952 73.1132 68.756 72.721 68.3325 72.4378C67.909 72.1546 67.417 71.9909 66.9083 71.964C64.9913 71.758 63.0993 71.352 61.1973 71.008C56.3083 70.124 54.0513 66.921 54.8693 62.008C56.2933 53.4234 57.7267 44.8387 59.1693 36.254C59.9253 31.746 63.4313 29.365 67.9803 30.147C75.1003 31.376 82.2353 32.547 89.3653 33.72C94.6193 34.584 96.8863 37.82 95.9863 43.112C94.5417 51.6047 93.121 60.1004 91.7243 68.599C91.0463 72.686 87.8943 75.22 83.7873 74.727C80.6263 74.347 77.4953 73.727 74.3493 73.211C74.1313 73.177 73.9143 73.172 73.5813 73.141ZM57.4393 63.461C57.3226 64.6153 57.6657 65.769 58.3944 66.6718C59.1231 67.5746 60.1784 68.1536 61.3313 68.283C68.7313 69.5117 76.1253 70.745 83.5133 71.983C86.3923 72.466 88.4793 71.104 88.9773 68.194C90.4733 59.4347 91.935 50.6717 93.3623 41.905C93.8453 38.924 92.4623 37.016 89.4813 36.513C82.2227 35.279 74.959 34.079 67.6903 32.913C64.0613 32.332 62.3443 33.705 61.7633 37.339C60.8483 43.056 59.8713 48.762 58.9203 54.468C58.4053 57.601 57.8863 60.742 57.4393 63.461Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M57.3463 72.3441C57.5463 73.3721 57.7213 74.2871 57.9273 75.3671C55.3273 75.8671 52.8073 76.4311 50.2573 76.8271C49.6174 76.8684 49.001 77.0837 48.4746 77.4498C47.9482 77.8158 47.5318 78.3187 47.2703 78.9041C46.5403 80.4311 45.5843 81.8491 44.5043 83.6841C44.1043 81.6331 43.7793 79.9621 43.4253 78.1531C40.5973 78.6931 37.8893 79.2741 35.1543 79.7001C33.5759 80.022 31.9604 80.123 30.3543 80.0001C28.9662 79.7623 27.6879 79.0945 26.6999 78.0909C25.712 77.0873 25.0642 75.7987 24.8483 74.4071C23.2316 65.2671 21.6393 56.1197 20.0713 46.9651C19.8098 45.1362 20.2737 43.2775 21.3639 41.7859C22.4542 40.2944 24.0843 39.2882 25.9063 38.9821C33.6789 37.5734 41.4619 36.2248 49.2553 34.9361C51.0549 34.7037 52.8743 35.1805 54.3287 36.2656C55.7831 37.3506 56.7584 38.9588 57.0483 40.7501C56.0973 40.9251 55.1483 41.1051 54.2263 41.2751C52.6943 38.2621 51.6263 37.7021 48.2473 38.2831C41.0813 39.5058 33.9193 40.7547 26.7613 42.0301C24.0363 42.5181 22.7873 44.4921 23.2703 47.2471C24.7763 55.8171 26.2636 64.3918 27.7323 72.9711C28.2723 76.1271 30.0763 77.5051 33.2383 76.9141C41.0003 75.4591 48.7583 73.9581 56.5153 72.4831C56.7393 72.4311 56.9613 72.3971 57.3463 72.3441Z",
          fill: "#EC4B1D",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M53.6874 58.4291C53.6141 61.601 52.3325 64.6252 50.1044 66.8839C47.8764 69.1427 44.87 70.4655 41.6994 70.5821C38.6128 70.6518 35.6133 69.5562 33.2983 67.5136C30.9833 65.471 29.5226 62.6313 29.2074 59.5601C29.1764 59.2461 29.1864 58.9331 29.1764 58.6191C29.1504 57.6191 29.5924 56.9281 30.6154 56.8661C31.7204 56.7991 32.2094 57.5141 32.3154 58.5471C32.3458 59.128 32.4126 59.7065 32.5154 60.2791C32.7672 61.4689 33.2563 62.5958 33.9535 63.5924C34.6506 64.5889 35.5415 65.4347 36.5729 66.0792C37.6043 66.7237 38.755 67.1537 39.9563 67.3435C41.1576 67.5332 42.3849 67.4789 43.5647 67.1837C44.7445 66.8884 45.8528 66.3584 46.8231 65.6253C47.7935 64.8921 48.6062 63.9709 49.2125 62.9166C49.8188 61.8623 50.2064 60.6966 50.3521 59.4892C50.4978 58.2818 50.3986 57.0573 50.0604 55.8891C49.9884 55.6271 49.9114 55.3701 49.8604 55.1081C49.804 54.9235 49.785 54.7295 49.8045 54.5374C49.824 54.3454 49.8816 54.1592 49.974 53.9897C50.0664 53.8202 50.1917 53.6708 50.3425 53.5504C50.4933 53.4299 50.6667 53.3407 50.8524 53.2881C51.0415 53.2042 51.2467 53.1632 51.4535 53.1678C51.6603 53.1725 51.8636 53.2228 52.0487 53.315C52.2338 53.4073 52.3963 53.5393 52.5245 53.7017C52.6527 53.864 52.7435 54.0526 52.7904 54.2541C53.1784 55.6121 53.3944 57.0291 53.6874 58.4291Z",
          fill: "#EC4B1D",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M75.4116 66.8751C73.5799 66.8451 71.7774 66.4118 70.1322 65.6061C68.4871 64.8003 67.0397 63.6419 65.8931 62.2131C64.7465 60.7844 63.9289 59.1206 63.4985 57.34C63.068 55.5594 63.0353 53.7058 63.4026 51.9111C63.7266 50.4051 64.3946 49.7671 65.4586 49.9531C66.5226 50.1391 66.9036 50.9711 66.6306 52.5031C66.3675 53.7238 66.3605 54.9859 66.6098 56.2095C66.8591 57.4331 67.3595 58.5918 68.0792 59.6123C68.799 60.6328 69.7225 61.4929 70.7915 62.1385C71.8605 62.784 73.0517 63.2009 74.2899 63.3627C75.5282 63.5246 76.7865 63.428 77.9855 63.079C79.1846 62.7299 80.2982 62.1361 81.2561 61.3349C82.214 60.5338 82.9954 59.5427 83.5509 58.4243C84.1064 57.3059 84.424 56.0844 84.4836 54.8371C84.4936 54.5231 84.4936 54.2101 84.4836 53.8911C84.4526 52.7651 84.9406 52.0351 86.1076 52.0351C87.2956 52.0351 87.6806 52.8111 87.7376 53.9061C87.8671 56.5745 87.1148 59.2113 85.5966 61.4096C84.0785 63.6078 81.8789 65.2452 79.3376 66.0691C78.0469 66.4188 76.7357 66.688 75.4116 66.8751Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_7_68",
                x1: "98",
                y1: "9.27941e-06",
                x2: "13.5",
                y2: "115",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#A86C8D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#4417DE" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }